
        import { Mapper } from "../../../../base/utils/mapper";
        import { SpasticityNeurologyModel } from "../../../../domain/models/consult/spasticity-neurology.model";
        import { SpasticityNeurologyEntity } from "../entities/spasticity-neurology.entity";
      
        export class SpasticityNeurologyImplementationRepositoryRepositoryMapper extends Mapper< SpasticityNeurologyEntity,  SpasticityNeurologyModel>{
            mapFrom(param:  SpasticityNeurologyEntity):  SpasticityNeurologyModel { 
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors
                }; 
            }
            mapTo(param:  SpasticityNeurologyModel):  SpasticityNeurologyEntity {
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors 
                };
            }
        }